import { Button } from '@iwoca/orion';

import styles from './NotOnboarded.module.css';
import { buildQueryString } from '../../../Buyer/utils/queryParams';
import logo from '../../../components/svg/iwocaPayLogo.svg';

export const NotOnboarded = () => {
  const queryString = buildQueryString();

  return (
    <div className={styles.wrap}>
      <img src={logo} alt="" />
      <p>You have not finished seller onboarding</p>
      <Button href={`/pay/activation${queryString}`}>
        Click here to continue
      </Button>
    </div>
  );
};
